import React from "react";
import { Link, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../components/Layout/Loader";

const MyProfileRedirectPage = () => {
  const { loading, user } = useSelector((state) => state.user);

  if (loading !== false) {
    return <Loader />;
  }

  if (user?.handle) {
    return <Navigate to={`/my-profile/${user.handle}`} replace />;
  }

  return (
    <div className="login-component-container">
      <div className="login-component-header">
        <h2 className="login-component-title">Profile setup is incomplete</h2>
      </div>
      <div className="login-component-form-container">
        <div className="login-component-form-wrapper">
          <p>Your account is signed in, but the profile handle is missing.</p>
          <div className="login-component-signup-link">
            <Link to="/profile" className="login-component-signup-text">
              Open account settings
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProfileRedirectPage;